<!-- src/components/VueTableCell.vue -->

<template>
    <td class="table-td p-2 lg:p-4 border border-cal-888888 lg:border-0" :data-label="columnTitle" >
        <span v-if="column.html" v-html="applyTransform(column, row[index])"></span>
        <span v-else v-html="applyTransform(column, row[index], row)"></span>
    </td>
</template>

<script>
export default {
    props: ['column', 'index', 'row'],

    data() {
      return {
        columnTitle: this.column.title,
      }
    },
    methods: {

        applyTransform (column, value, row) {
            if (column.transform) {
                value = column.transform(value, row);
            }
            if (!value) {
                return "–";
            }
            return value;
        }
    }
}
</script>
